import { Component, HostBinding, Input, OnInit } from "@angular/core"
import { Resource } from "../../../models/resource/resource"
import { SupportMaterial } from "../../../models/supportMaterial.model"
import { ModalService } from "../../../shared-components/modal/modal.service"
import { TextDisplayModalComponent } from "../../../shared-components/modals/text-display-modal/text-display-modal.component"
import Utils from "../../../utils/utils"
import { AddOnViewService } from "../../../services/add-on-view.service"

@Component({
    selector: "app-support-material-panel",
    templateUrl: "./support-material-panel.component.html",
    styleUrls: ["./support-material-panel.component.scss"],
    standalone: false,
})
export class SupportMaterialPanelComponent implements OnInit {
    @Input() resource: Resource
    mediaInLessonAccordionId: string
    supportMaterialForStudentsAccordionId: string
    supportMaterialForTeachersAccordionId: string
    isTeacherPreview: boolean
    openModalIds: string[] = []

    @HostBinding("class.d-none") isEmpty

    constructor(
        private modalService: ModalService,
        private addOnViewService: AddOnViewService
    ) {}

    public ngOnInit() {
        this.isTeacherPreview = this.addOnViewService.isTeacherPreview
        this.initAccordion()
        this.isEmpty =
            !this.resource.lessonContents.length &&
            !this.resource.supportMaterialsForTeachersByCategory.length &&
            !this.resource.supportMaterialsForStudentsByCategory.length
        this.preOpenModalsForSEO()
    }

    public openSupportMaterial(supportMaterial: SupportMaterial, e: MouseEvent) {
        e.preventDefault()

        if (supportMaterial.isHTMLFragment()) {
            this.modalService.open(supportMaterial.guid)
        } else {
            Utils.openInNewTab(supportMaterial.canonicalURL)
        }
    }

    private initAccordion() {
        this.mediaInLessonAccordionId = `${this.resource.favoriteId}-mediaInLesson`
        this.supportMaterialForStudentsAccordionId = `${this.resource.favoriteId}-supportMaterialForStudents`
        this.supportMaterialForTeachersAccordionId = `${this.resource.favoriteId}-supportMaterialForTeachers`
    }

    private preOpenModalsForSEO() {
        const allSupportMaterials = [
            ...this.resource.supportMaterialsForStudentsByCategory,
            ...this.resource.supportMaterialsForTeachersByCategory,
        ]

        allSupportMaterials.forEach((category) =>
            category.items.forEach((sm) => {
                if (sm.mediaType === "HTMLFragment") {
                    this.openModalIds.push(sm.guid)
                    this.modalService.open(TextDisplayModalComponent, {
                        id: sm.guid,
                        size: "lg",
                        windowClass: "text-display-modal",
                        persisted: true,
                        data: {
                            text: sm.getContent(),
                            role: sm.title,
                            printURL: sm.printUrl,
                        },
                    })
                }
            })
        )
    }
}
